import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthButton from '../components/Navbar/AuthButton'; // <-- import AuthButton
import { useStrings } from '../i18n';

function Login() {
  const strings = useStrings();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, userInfo } = useAuth();

  // Where to send the user after a successful login.
  // ProtectedRoute sets location.state.from so we can return them to the page
  // they were trying to visit. Fall back to '/' for direct /login visits.
  const redirectTo = location.state?.from || '/';

  useEffect(() => {
    // If already authenticated, redirect to intended destination (or admin if applicable)
    if (isAuthenticated && userInfo?.role) {
      if (userInfo.role === 'admin' || userInfo.role === 'superadmin') {
        navigate('/admin', { replace: true });
      } else {
        navigate(redirectTo, { replace: true });
      }
    }
  }, [isAuthenticated, userInfo, navigate, redirectTo]);

  return (
    <div className="flex flex-col items-center justify-center w-full min-h-[60vh] px-4">
      <h2 className="text-2xl md:text-3xl mb-6 md:mb-8 text-center">{strings.authPages.loginHeader}</h2>
      {/* AuthButton handles Google sign-in; after auth, the useEffect above redirects */}
      <AuthButton redirectTo={redirectTo} />
    </div>
  );
}

export default Login;
